import { _config } from 'Utilities/envConfig';
import log from 'Utilities/log';
export const notifyApp = (topic, data) => {
  const message = JSON.stringify({
    topic,
    data
  });
  if (_config.environment !== 'production') {
    log.info(message);
  }
  window.ReactNativeWebView?.postMessage(message);
};